module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 3);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, r) {
  e.exports = r(4)();
}, function (e, t) {
  e.exports = function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 0);
  }([function (e, t, r) {
    "use strict";

    r.r(t), r.d(t, "validateHTMLColorName", function () {
      return n;
    }), r.d(t, "validateHTMLColor", function () {
      return o;
    });

    var n = function n(e) {
      var t = !1;
      return "string" == typeof e && ["IndianRed", "LightCoral", "Salmon", "DarkSalmon", "LightSalmon", "Crimson", "Red", "FireBrick", "DarkRed", "Pink", "LightPink", "HotPink", "DeepPink", "MediumVioletRed", "PaleVioletRed", "LightSalmon", "Coral", "Tomato", "OrangeRed", "DarkOrange", "Orange", "Gold", "Yellow", "LightYellow", "LemonChiffon", "LightGoldenrodYellow", "PapayaWhip", "Moccasin", "PeachPuff", "PaleGoldenrod", "Khaki", "DarkKhaki", "Lavender", "Thistle", "Plum", "Violet", "Orchid", "Fuchsia", "Magenta", "MediumOrchid", "MediumPurple", "RebeccaPurple", "BlueViolet", "DarkViolet", "DarkOrchid", "DarkMagenta", "Purple", "Indigo", "SlateBlue", "DarkSlateBlue", "MediumSlateBlue", "GreenYellow", "Chartreuse", "LawnGreen", "Lime", "LimeGreen", "PaleGreen", "LightGreen", "MediumSpringGreen", "SpringGreen", "MediumSeaGreen", "SeaGreen", "ForestGreen", "Green", "DarkGreen", "YellowGreen", "OliveDrab", "Olive", "DarkOliveGreen", "MediumAquamarine", "DarkSeaGreen", "LightSeaGreen", "DarkCyan", "Teal", "Aqua", "Cyan", "LightCyan", "PaleTurquoise", "Aquamarine", "Turquoise", "MediumTurquoise", "DarkTurquoise", "CadetBlue", "SteelBlue", "LightSteelBlue", "PowderBlue", "LightBlue", "SkyBlue", "LightSkyBlue", "DeepSkyBlue", "DodgerBlue", "CornflowerBlue", "MediumSlateBlue", "RoyalBlue", "Blue", "MediumBlue", "DarkBlue", "Navy", "MidnightBlue", "Cornsilk", "BlanchedAlmond", "Bisque", "NavajoWhite", "Wheat", "BurlyWood", "Tan", "RosyBrown", "SandyBrown", "Goldenrod", "DarkGoldenrod", "Peru", "Chocolate", "SaddleBrown", "Sienna", "Brown", "Maroon", "White", "Snow", "HoneyDew", "MintCream", "Azure", "AliceBlue", "GhostWhite", "WhiteSmoke", "SeaShell", "Beige", "OldLace", "FloralWhite", "Ivory", "AntiqueWhite", "Linen", "LavenderBlush", "MistyRose", "Gainsboro", "LightGray", "Silver", "DarkGray", "Gray", "DimGray", "LightSlateGray", "SlateGray", "DarkSlateGray", "Black", "Transparent"].map(function (r) {
        e.toLowerCase() === r.toLowerCase() && (t = !0);
      }), t;
    },
        o = function o(e) {
      if ("string" == typeof e) {
        var _t = /^#([\da-f]{3}){1,2}$|^#([\da-f]{4}){1,2}$|(rgb|hsl)a?\((\s*-?\d+%?\s*,){2}(\s*-?\d+%?\s*,?\s*\)?)(,\s*(0?\.\d+)?|1)?\)/i;
        return !(!e || !_t.test(e));
      }
    };

    t.default = function (e) {
      return !(!e || !n(e) && !o(e));
    };
  }]);
}, function (e, t, r) {
  "use strict";

  r.r(t);
  var n = r(0),
      o = r.n(n),
      a = r(1),
      i = r.n(a),
      l = r(2),
      s = r.n(l);
  r(6);

  function u(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {},
          n = Object.keys(r);
      "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
        return Object.getOwnPropertyDescriptor(r, e).enumerable;
      }))), n.forEach(function (t) {
        c(e, t, r[t]);
      });
    }

    return e;
  }

  function c(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  var f = function f(e) {
    var t = e.colorBackground,
        r = void 0 === t ? "" : t,
        n = e.colorOctocat,
        a = void 0 === n ? "" : n,
        i = e.repo,
        l = void 0 === i ? "" : i,
        c = e.side,
        f = void 0 === c ? "right" : c,
        d = e.text,
        p = void 0 === d ? "Fork me on GitHub" : d,
        m = e.isDocumentation,
        h = void 0 !== m && m,
        y = e.isPride,
        v = void 0 !== y && y,
        b = h ? {
      position: "relative"
    } : u({
      position: "absolute",
      top: "0"
    }, "left" === f ? {
      left: "0"
    } : {
      right: "0"
    });
    return o.a.createElement("a", {
      href: l,
      className: "fork-me-on-github",
      "aria-label": p,
      style: u({}, b)
    }, function (e) {
      var t = e.isPride,
          r = e.colorBackground,
          n = e.colorOctocat,
          a = e.side,
          i = n && s()(n) ? n : "white",
          l = "left" === a ? {
        transform: "scale(-1, 1)"
      } : {};
      return o.a.createElement(o.a.Fragment, null, t && o.a.createElement("svg", {
        style: {
          width: "0",
          height: "0",
          position: "absolute"
        },
        "aria-hidden": "true",
        focusable: "false"
      }, o.a.createElement("linearGradient", {
        id: "prideGradient",
        x2: "1",
        y2: "1"
      }, o.a.createElement("stop", {
        offset: "0%",
        stopColor: "#f00000"
      }), o.a.createElement("stop", {
        offset: "16.67%",
        stopColor: "#f00000"
      }), o.a.createElement("stop", {
        offset: "16.67%",
        stopColor: "#ff8000"
      }), o.a.createElement("stop", {
        offset: "33.33%",
        stopColor: "#ff8000"
      }), o.a.createElement("stop", {
        offset: "33.33%",
        stopColor: "#ffff00"
      }), o.a.createElement("stop", {
        offset: "50%",
        stopColor: "#ffff00"
      }), o.a.createElement("stop", {
        offset: "50%",
        stopColor: "#007940"
      }), o.a.createElement("stop", {
        offset: "66.67%",
        stopColor: "#007940"
      }), o.a.createElement("stop", {
        offset: "66.67%",
        stopColor: "#4040ff"
      }), o.a.createElement("stop", {
        offset: "83.33%",
        stopColor: "#4040ff"
      }), o.a.createElement("stop", {
        offset: "83.33%",
        stopColor: "#a000c0"
      }), o.a.createElement("stop", {
        offset: "100%",
        stopColor: "#a000c0"
      }))), o.a.createElement("svg", {
        width: "80",
        height: "80",
        viewBox: "0 0 250 250",
        style: u({
          border: "0",
          color: i,
          fill: t ? "url(#prideGradient) #f00000" : r && s()(r) ? r : "black"
        }, l),
        "aria-hidden": "true"
      }, o.a.createElement("path", {
        d: "M0,0 L115,115 L130,115 L142,142 L250,250 L250,0 Z"
      }), o.a.createElement("path", {
        d: "M128.3,109.0 C113.8,99.7 119.0,89.6 119.0,89.6 C122.0,82.7 120.5,78.6 120.5,78.6 C119.2,72.0 123.4,76.3 123.4,76.3 C127.3,80.9 125.5,87.3 125.5,87.3 C122.9,97.6 130.6,101.9 134.4,103.2",
        fill: "currentColor",
        style: {
          transformOrigin: "130px 106px"
        },
        className: "octo-arm"
      }), o.a.createElement("path", {
        d: "M115.0,115.0 C114.9,115.1 118.7,116.5 119.8,115.4 L133.7,101.6 C136.9,99.2 139.9,98.4 142.2,98.6 C133.8,88.0 127.5,74.4 143.8,58.0 C148.5,53.4 154.0,51.2 159.7,51.0 C160.3,49.4 163.2,43.6 171.4,40.1 C171.4,40.1 176.1,42.5 178.8,56.2 C183.1,58.6 187.2,61.8 190.9,65.4 C194.5,69.0 197.7,73.2 200.1,77.6 C213.8,80.2 216.3,84.9 216.3,84.9 C212.7,93.1 206.9,96.0 205.4,96.6 C205.1,102.4 203.0,107.8 198.3,112.5 C181.9,128.9 168.3,122.5 157.7,114.1 C157.9,116.9 156.7,120.9 152.7,124.9 L141.0,136.5 C139.8,137.7 141.6,141.9 141.8,141.8 Z",
        fill: "currentColor",
        className: "octo-body"
      })));
    }({
      isPride: v,
      colorBackground: r,
      colorOctocat: a,
      side: f
    }));
  };

  f.propTypes = {
    colorBackground: i.a.string,
    colorOctocat: i.a.string,
    isDocumentation: i.a.bool,
    isPride: i.a.bool,
    repo: i.a.string.isRequired,
    side: i.a.oneOf(["left", "right"]),
    text: i.a.string
  }, t.default = f;
}, function (e, t, r) {
  "use strict";

  var n = r(5);

  function o() {}

  function a() {}

  a.resetWarningCache = o, e.exports = function () {
    function e(e, t, r, o, a, i) {
      if (i !== n) {
        var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw l.name = "Invariant Violation", l;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var r = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: a,
      resetWarningCache: o
    };
    return r.PropTypes = r, r;
  };
}, function (e, t, r) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, t, r) {
  var n = r(7);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  r(9)(n, o);
  n.locals && (e.exports = n.locals);
}, function (e, t, r) {
  (e.exports = r(8)(!1)).push([e.i, "@keyframes octocat-wave {\n  0%,\n  100% {\n    transform: rotate(0); }\n  20%,\n  60% {\n    transform: rotate(-25deg); }\n  40%,\n  80% {\n    transform: rotate(10deg); } }\n\n.fork-me-on-github:hover .octo-arm {\n  animation: octocat-wave 560ms ease-in-out; }\n\n@media (max-width: 500px) {\n  .fork-me-on-github:hover .octo-arm {\n    animation: none; }\n  .fork-me-on-github .octo-arm {\n    animation: octocat-wave 560ms ease-in-out; } }\n", ""]);
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    var t = [];
    return t.toString = function () {
      return this.map(function (t) {
        var r = function (e, t) {
          var r = e[1] || "",
              n = e[3];
          if (!n) return r;

          if (t && "function" == typeof btoa) {
            var o = (i = n, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(i)))) + " */"),
                a = n.sources.map(function (e) {
              return "/*# sourceURL=" + n.sourceRoot + e + " */";
            });
            return [r].concat(a).concat([o]).join("\n");
          }

          var i;
          return [r].join("\n");
        }(t, e);

        return t[2] ? "@media " + t[2] + "{" + r + "}" : r;
      }).join("");
    }, t.i = function (e, r) {
      "string" == typeof e && (e = [[null, e, ""]]);

      for (var n = {}, o = 0; o < this.length; o++) {
        var a = this[o][0];
        null != a && (n[a] = !0);
      }

      for (o = 0; o < e.length; o++) {
        var i = e[o];
        null != i[0] && n[i[0]] || (r && !i[2] ? i[2] = r : r && (i[2] = "(" + i[2] + ") and (" + r + ")"), t.push(i));
      }
    }, t;
  };
}, function (e, t, r) {
  var n,
      o,
      a = {},
      i = (n = function n() {
    return window && document && document.all && !window.atob;
  }, function () {
    return void 0 === o && (o = n.apply(this, arguments)), o;
  }),
      l = function (e) {
    var t = {};
    return function (e, r) {
      if ("function" == typeof e) return e();

      if (void 0 === t[e]) {
        var n = function (e, t) {
          return t ? t.querySelector(e) : document.querySelector(e);
        }.call(this, e, r);

        if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
          n = n.contentDocument.head;
        } catch (e) {
          n = null;
        }
        t[e] = n;
      }

      return t[e];
    };
  }(),
      s = null,
      u = 0,
      c = [],
      f = r(10);

  function d(e, t) {
    for (var r = 0; r < e.length; r++) {
      var n = e[r],
          o = a[n.id];

      if (o) {
        o.refs++;

        for (var i = 0; i < o.parts.length; i++) {
          o.parts[i](n.parts[i]);
        }

        for (; i < n.parts.length; i++) {
          o.parts.push(b(n.parts[i], t));
        }
      } else {
        var l = [];

        for (i = 0; i < n.parts.length; i++) {
          l.push(b(n.parts[i], t));
        }

        a[n.id] = {
          id: n.id,
          refs: 1,
          parts: l
        };
      }
    }
  }

  function p(e, t) {
    for (var r = [], n = {}, o = 0; o < e.length; o++) {
      var a = e[o],
          i = t.base ? a[0] + t.base : a[0],
          l = {
        css: a[1],
        media: a[2],
        sourceMap: a[3]
      };
      n[i] ? n[i].parts.push(l) : r.push(n[i] = {
        id: i,
        parts: [l]
      });
    }

    return r;
  }

  function m(e, t) {
    var r = l(e.insertInto);
    if (!r) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
    var n = c[c.length - 1];
    if ("top" === e.insertAt) n ? n.nextSibling ? r.insertBefore(t, n.nextSibling) : r.appendChild(t) : r.insertBefore(t, r.firstChild), c.push(t);else if ("bottom" === e.insertAt) r.appendChild(t);else {
      if ("object" != typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
      var o = l(e.insertAt.before, r);
      r.insertBefore(t, o);
    }
  }

  function h(e) {
    if (null === e.parentNode) return !1;
    e.parentNode.removeChild(e);
    var t = c.indexOf(e);
    t >= 0 && c.splice(t, 1);
  }

  function y(e) {
    var t = document.createElement("style");

    if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
      var n = function () {
        0;
        return r.nc;
      }();

      n && (e.attrs.nonce = n);
    }

    return v(t, e.attrs), m(e, t), t;
  }

  function v(e, t) {
    Object.keys(t).forEach(function (r) {
      e.setAttribute(r, t[r]);
    });
  }

  function b(e, t) {
    var r, n, o, a;

    if (t.transform && e.css) {
      if (!(a = "function" == typeof t.transform ? t.transform(e.css) : t.transform.default(e.css))) return function () {};
      e.css = a;
    }

    if (t.singleton) {
      var i = u++;
      r = s || (s = y(t)), n = O.bind(null, r, i, !1), o = O.bind(null, r, i, !0);
    } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (r = function (e) {
      var t = document.createElement("link");
      return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", v(t, e.attrs), m(e, t), t;
    }(t), n = function (e, t, r) {
      var n = r.css,
          o = r.sourceMap,
          a = void 0 === t.convertToAbsoluteUrls && o;
      (t.convertToAbsoluteUrls || a) && (n = f(n));
      o && (n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
      var i = new Blob([n], {
        type: "text/css"
      }),
          l = e.href;
      e.href = URL.createObjectURL(i), l && URL.revokeObjectURL(l);
    }.bind(null, r, t), o = function o() {
      h(r), r.href && URL.revokeObjectURL(r.href);
    }) : (r = y(t), n = function (e, t) {
      var r = t.css,
          n = t.media;
      n && e.setAttribute("media", n);
      if (e.styleSheet) e.styleSheet.cssText = r;else {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }

        e.appendChild(document.createTextNode(r));
      }
    }.bind(null, r), o = function o() {
      h(r);
    });

    return n(e), function (t) {
      if (t) {
        if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
        n(e = t);
      } else o();
    };
  }

  e.exports = function (e, t) {
    if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
    (t = t || {}).attrs = "object" == typeof t.attrs ? t.attrs : {}, t.singleton || "boolean" == typeof t.singleton || (t.singleton = i()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
    var r = p(e, t);
    return d(r, t), function (e) {
      for (var n = [], o = 0; o < r.length; o++) {
        var i = r[o];
        (l = a[i.id]).refs--, n.push(l);
      }

      e && d(p(e, t), t);

      for (o = 0; o < n.length; o++) {
        var l;

        if (0 === (l = n[o]).refs) {
          for (var s = 0; s < l.parts.length; s++) {
            l.parts[s]();
          }

          delete a[l.id];
        }
      }
    };
  };

  var g,
      C = (g = [], function (e, t) {
    return g[e] = t, g.filter(Boolean).join("\n");
  });

  function O(e, t, r, n) {
    var o = r ? "" : n.css;
    if (e.styleSheet) e.styleSheet.cssText = C(t, o);else {
      var a = document.createTextNode(o),
          i = e.childNodes;
      i[t] && e.removeChild(i[t]), i.length ? e.insertBefore(a, i[t]) : e.appendChild(a);
    }
  }
}, function (e, t) {
  e.exports = function (e) {
    var t = "undefined" != typeof window && window.location;
    if (!t) throw new Error("fixUrls requires window.location");
    if (!e || "string" != typeof e) return e;
    var r = t.protocol + "//" + t.host,
        n = r + t.pathname.replace(/\/[^\/]*$/, "/");
    return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
      var o,
          a = t.trim().replace(/^"(.*)"$/, function (e, t) {
        return t;
      }).replace(/^'(.*)'$/, function (e, t) {
        return t;
      });
      return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(a) ? e : (o = 0 === a.indexOf("//") ? a : 0 === a.indexOf("/") ? r + a : n + a.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
    });
  };
}]);